export { ActivityService } from './activity.service';
export { LineItemService } from './line-item.service';
export { InventoryItemService, type InventoryItemOption, type CreateInventoryItemInput } from './inventory-item.service';
export {
  LineItemDraftService,
  draftToFieldValues,
  draftToLineItem,
  type LineItemDraft,
} from './line-item-draft.service';
export { RecentLineItemsService } from './recent-line-items.service';
export { CrmObjectSaveHooksService, type CrmObjectSaveHook } from './crm-object-save-hooks.service';
export { OpportunityTotalSyncService } from './opportunity-total-sync.service';

export { CrmFiltersService } from './crm-filters.service';
export * from './crm-form.service';
// NOTE: This library intentionally does not re-export CrmFieldService from @galaxy/crm/static.
// Keep this list explicit so we only expose the shared field ID constants.
export {
  CompanyCustomColumns,
  ContactCustomColumns,
  NonStandardExternalIDs,
  OpportunityCustomColumns,
  PlatformExtensionFieldIds,
  StandardExternalIds,
  StandardIds,
  SystemFieldIds,
  TaskCustomColumns,
} from '@galaxy/crm/services/field-service';
export * from './crm-object-service';
